import useGlobalState from '@components/Hooks/useGlobalState';
import Bubble from '@Shared/Bubble';
import React, { useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

interface Props {
  show: boolean,
  verify: (token: string | null) => void
}

const GetStartedCaptcha: React.FC<Props> = (props) => {

  const [store,] = useGlobalState();

  useEffect(() => {
    setTimeout(() => {
      const widget = document.querySelector('altcha-widget');
      widget?.addEventListener('verified', (ev) => {
        // See enum State above
        const e = ev as unknown as { detail: { payload: string } };
        props.verify(e.detail.payload);
      });
    }, 1);
  }, [props.show, store.requested])

  return (!store.requested && props.show) ? (
    <div style={{ paddingTop: 27 }}>
      <Row>
        <Col xs={2} sm={1}>
          <Bubble>3</Bubble>
        </Col>
        <Col xs={10} sm={11}>

          <h2>Submit to you Administrator</h2>
          <Form.Group style={{ marginTop: 14 }} className='form-group'>
            {/* ALTCHA WebComponent */}
            <altcha-widget challenge="/api/users/do/challenge"></altcha-widget>
          </Form.Group>
        </Col>
      </Row>
    </div>
  ) : null;
}

export default GetStartedCaptcha;